import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * Mobile Nav Header
 * 
 * Contains Tappd logo and close button.
 * Consistent across all states.
 */
export default function MobileNavHeader({ onClose }) {
  return (
    <div className="flex items-center justify-between mb-6">
      {/* Tappd Logo */}
      <img 
        src="/tappd-logo-white.png" 
        alt="Tappd"
        className="h-10 w-auto object-contain"
      />
      
      {/* Close button */}
      <button
        onClick={onClose}
        type="button"
        aria-label="Close menu"
        className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <XMarkIcon className="w-5 h-5 text-white" aria-hidden="true" />
      </button>
    </div>
  );
}
